enum CropwiseAiTabsEnum {
  HIDE = 'HIDE',
  FULL_SCREEN = 'FULL_SCREEN',
  COLLAPSE = 'COLLAPSE',
}

export { CropwiseAiTabsEnum };
